import Vue from 'vue'
import {permissions} from '@/constants'

let isPermission = (state, perm) => state.account.token ? state.account.permissions.includes(perm) : false

export default {
  namespaced: true,
  state: {
    account: {
      token: false,
      locale: 'ru'
    },
    notifications: [],
    dashboard: {
      common_items: [],
      in_process_items: [],
      expired_items: [],
      controlled_items: [],
      announcements: [],
    },
    extendedDashboard: {},
    showNavigation: true
  },
  getters: {
    isWorkflowController: (state) => isPermission(state, permissions.WORKFLOW_CONTROLLER),
    isProjectManager: (state) => isPermission(state, permissions.PROJECT_CONTROL_MANAGER),
    isSurveyManager: (state) => isPermission(state, permissions.SURVEY_MANAGER),
    isAnnouncementManager: (state) => isPermission(state, permissions.ANNOUNCEMENT_MANAGER),
    isDocflowManager: (state) => isPermission(state, permissions.DOCFLOW_MANAGER),
    isDocflowApprover: (state) => isPermission(state, permissions.DOCFLOW_APPROVER),
    isDocflowController: (state) => isPermission(state, permissions.DOCFLOW_CONTROLLER),
    isDocflowSupervisor: (state) => isPermission(state, permissions.DOCFLOW_SUPERVISOR),
    isDocflowModerator: (state) => isPermission(state, permissions.DOCFLOW_MODERATOR),
    isDocflowAppealManager: (state) => isPermission(state, permissions.DOCFLOW_APPEAL_MANAGER),
    isDocflowOutgoingManager: (state) => isPermission(state, permissions.DOCFLOW_OUTGOING_MANAGER),
    isDocflowAssistant: (state) => isPermission(state, permissions.DOCFLOW_ASSISTANT),
    isDocflowHead: (state) => isPermission(state, permissions.DOCFLOW_HEAD),
    isDocflowExecutiveOfficer: (state) => isPermission(state, permissions.DOCFLOW_EXECUTIVE_OFFICER),
    isSuperUser: (state) => isPermission(state, permissions.SUPER_USER),
    isReportsManager: (state) => isPermission(state, permissions.REPORTS_MANAGER),
    isDocflowPlanCreator: (state) => isPermission(state, permissions.DOCFLOW_PLAN_CREATOR),
    documentPreview: (state) => state.account.employee.document_preview,
    canAcceptTask: state => state.account.can_maintainer_accept_task
  },
  mutations: {
    SET_ACCOUNT(state, account) {
      state.account = account
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    SET_DASHBOARD(state, dashboard) {
      state.dashboard = dashboard
    },
    SET_EXTENDED_DASHBOARD(state, dashboard) {
      state.extendedDashboard = dashboard
    },
    SET_PREVIEW(state, preview) {
      state.account.employee.document_preview = preview
    },
    SET_NAVIGATION_VISIBILITY(state, value) {
      state.showNavigation = value
    },
    CHANGE_LANG(state, locale) {
      state.account = {
        ...state.account,
        locale
      }
    },
    LOGOUT(state) {
      state.account = {
        token: false,
        locale: 'ru'
      }
    }
  },
  actions: {
    login({commit}, credentials) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('auth/', credentials)
          .then((response) => {
            commit('SET_ACCOUNT', response.data)
            resolve(response.data)
          }).catch((error) => {
            reject(error.response)
          })
      })
    },
    changePassword({}, credentials) {
      return new Promise((resolve, reject) => {
        Vue.axios.patch('account/change_password/', credentials)
          .then((response) => {
            resolve(response.data)
          }).catch((error) => {
          reject(error.response)
        })
      })
    },
    esiAuth({commit}, code) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('esi_auth/', {code})
          .then((response) => {
            commit('SET_ACCOUNT', response.data)
            resolve(response.data)
          }).catch((error) => {
            reject(error.response)
          })
      })
    },
    notificationsList({commit}) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('notifier/notifications/', { __silent: true }).then((response) => {
          commit('SET_NOTIFICATIONS', response.data.results)
          resolve(response.data)
        }).catch((error) => {
          reject(error.response)
        })
      })
    },
    getDashboardData({commit}) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('account/dashboard/').then((response) => {
          commit('SET_DASHBOARD', response.data)
          resolve(response.data)
        }).catch((error) => {
          reject(error.response)
        })
      })
    },
    getExtendedDashboardData({commit}) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('account/panel/').then((response) => {
          let data = {}
          Object.keys(response.data).map(o => {
            data[o] = response.data[o].map(item => ({
              ...item,
              resolution_tasks: [
                {
                  term_date: item.resolution_term_date,
                  description: false,
                  is_maintainer: true,
                  employee: {initials: item.resolution_maintainer__initials}
                },
                ...item.resolution_tasks
              ]
            }))
          })
          commit('SET_EXTENDED_DASHBOARD', data)
          resolve(data)
        }).catch((error) => {
          reject(error.response)
        })
      })
    }
  }
}
